import { baseApi } from "@/services/base.service";
import { modesAPI } from "@/services/modes.service";
import { RESOURCES } from "@/services/resources";

type DispatchLike = (action: unknown) => unknown;

/**
 * Tags RTK Query cujo cache depende do EventoId atual.
 * Invalidar o tipo sem `id` remove/refetcha todas as entradas daquele tipo.
 */
const EVENTO_SCOPED_TAG_TYPES: string[] = [
  // Metadados espelhados no slice (PascalCase usados em eventos.service)
  "Campos",
  "EquipesEvento",
  "EquipesFormularioEvento",
  "CirculosEvento",
  "EtiquetasEvento",
  "CredenciaisEvento",
  "IgrejasEvento",
  "PadrinhosEvento",
  "ReunioesEvento",
  "MensagensEvento",
  "FormasPagamentoEvento",
  "CentroCustosEvento",
  "QuartosParticipantesEvento",
  "QuartosVoluntáriosEvento",
  "CaronasEvento",
  "VoluntariosEvento",
  "Adicionais",
  "Cupons",
  "CuponsResumo",
  "CupomUtilizacoes",
  "ResumoEvento",
  // Listagens / selects / perfil
  "Participantes",
  "Equipante",
  "Equipantes",
  "SelectParticipantes",
  "SelectCasais",
  "SelectAddVoluntario",
  "EquipesMembros",
  "Equipe",
  "Equipes",
  // Tags PascalCase usadas na home (coordenador/dirigente/círculos) — NÃO são kebab do RESOURCES
  "Coordenador",
  "Dirigente",
  "DirigentesCirculo",
  "ParticipantesCirculos",
  "ParticipantesCirculosAvulsos",
  "CirculosCompleto",
  "Círculos",
  "ListagemGeral",
  // Mais PascalCase usados em services (≠ kebab do RESOURCES)
  "Historico",
  "Padrinhos",
  "Presenca",
  "ParticipantesPadrinhos",
  "ParticipantesQuartos",
  "ParticipantesCaronas",
  "EquipantesQuartosAvulsos",
  "ProdutoMovimentacao",
  "ESTATISTICAS_PRODUTOS",
  "ESTATISTICAS_FORMAS_PAGAMENTO",
  // RESOURCES (kebab / lowercase) usados em providesTags
  RESOURCES.CAMPOS,
  RESOURCES.EQUIPES_EVENTO,
  RESOURCES.EQUIPES_FORMULARIO_EVENTO,
  RESOURCES.CIRCLES_EVENTO,
  RESOURCES.CIRCLES,
  RESOURCES.ETIQUETAS_EVENTO,
  RESOURCES.PRODUTOS_EVENTO,
  RESOURCES.PRODUTOS,
  RESOURCES.PRODUTO,
  RESOURCES.PRODUTO_MOVIMENTACAO,
  RESOURCES.GRUPOS_EVENTO,
  RESOURCES.GRUPOS,
  RESOURCES.CREDENCIAIS_EVENTO,
  RESOURCES.IGREJAS_EVENTO,
  RESOURCES.PADRINHOS_EVENTO,
  RESOURCES.REUNIOES_EVENTO,
  RESOURCES.MENSAGENS_EVENTO,
  RESOURCES.FORMAS_PAGAMENTO_EVENTO,
  RESOURCES.CENTRO_CUSTOS_EVENTO,
  RESOURCES.QUARTOS_PARTICIPANTES_EVENTO,
  RESOURCES.QUARTOS_VOLUNTARIOS_EVENTO,
  RESOURCES.CARONAS_EVENTO,
  RESOURCES.CARONAS,
  RESOURCES.VOLUNTARIOS_EVENTO,
  RESOURCES.ADICIONAIS,
  RESOURCES.RESUMO_EVENTO,
  RESOURCES.PARTICIPANTES,
  RESOURCES.PARTICIPANTE,
  RESOURCES.EQUIPANTE,
  RESOURCES.EQUIPANTES,
  RESOURCES.EQUIPES,
  RESOURCES.EQUIPE,
  RESOURCES.EQUIPES_MEMBROS,
  RESOURCES.SELECT_PARTICIPANTES,
  RESOURCES.SELECT_CASAIS,
  RESOURCES.SELECT_ADD_VOLUNTARIO,
  RESOURCES.QUARTOS,
  RESOURCES.PADRINHOS,
  RESOURCES.REUNIOES,
  RESOURCES.HISTORICO,
  RESOURCES.LANCAMENTOS,
  RESOURCES.VENDAS,
  RESOURCES.VENDAS_SALDO,
  RESOURCES.MARCADORES,
  RESOURCES.PRESENCA,
  RESOURCES.PARTICIPANTES_CIRCLES,
  RESOURCES.PARTICIPANTES_CIRCLES_AVULSOS,
  RESOURCES.PARTICIPANTES_PADRINHOS,
  RESOURCES.PARTICIPANTES_PADRINHOS_AVULSOS,
  RESOURCES.PARTICIPANTES_QUARTOS,
  RESOURCES.PARTICIPANTES_QUARTOS_AVULSOS,
  RESOURCES.PARTICIPANTES_CARONAS,
  RESOURCES.PARTICIPANTES_CARONAS_AVULSOS,
  RESOURCES.EQUIPANTES_QUARTOS_AVULSOS,
  RESOURCES.DIRIGENTES_CIRCULO,
  RESOURCES.DIRIGENTE,
  RESOURCES.COORDENADOR,
];

const CONFIGURACAO_SCOPED_TAG_TYPES: string[] = [
  "GruposConfiguracao",
  "Campos",
  "EquipesEvento",
  "EquipesFormularioEvento",
  RESOURCES.GRUPOS_CONFIGURACAO,
  RESOURCES.GRUPOS,
  RESOURCES.PRODUTOS,
  RESOURCES.PRODUTO,
  RESOURCES.PRODUTOS_EVENTO,
  RESOURCES.CAMPOS,
  RESOURCES.CAMPOS_PERSONALIZADOS,
  RESOURCES.EQUIPES_EVENTO,
  RESOURCES.EQUIPES_FORMULARIO_EVENTO,
  RESOURCES.CONFIGURACOES,
  RESOURCES.CENTRO_CUSTOS_CONFIGURACAO,
];

function uniqueTags(tags: string[]): string[] {
  return [...new Set(tags)];
}

/** Invalida cache RTK dependente do EventoId (e Modes). */
export function invalidateContextoEvento(dispatch: DispatchLike) {
  dispatch(baseApi.util.invalidateTags(uniqueTags(EVENTO_SCOPED_TAG_TYPES)));
  dispatch(modesAPI.util.invalidateTags(["Modes"]));
}

/** Invalida cache RTK dependente do ConfiguracaoId (e Modes). */
export function invalidateContextoConfiguracao(dispatch: DispatchLike) {
  dispatch(baseApi.util.invalidateTags(uniqueTags(CONFIGURACAO_SCOPED_TAG_TYPES)));
  dispatch(modesAPI.util.invalidateTags(["Modes"]));
}
